import { IDeviceFingerprint } from "config/types";
import { setDeviceFingerprint } from "store/actions/device-fingerprint";

import { createReducer } from "@reduxjs/toolkit";

const defaultState: IDeviceFingerprint = {
  fingerprint: "",
  loading: false,
  error: null,
  loaded: false,
};

const deviceFingerprint = createReducer(defaultState, builder => {
  builder
    .addCase(setDeviceFingerprint.pending, state => {
      state.loading = true;
      state.loaded = false;
    })
    .addCase(setDeviceFingerprint.fulfilled, (state, action) => ({
      fingerprint: action.payload,
      loading: false,
      error: null,
      loaded: true,
    }))
    .addCase(setDeviceFingerprint.rejected, (state, action) => ({
      fingerprint: "",
      loading: false,
      error: (action.payload as string | null) ?? null,
      loaded: false,
    }));
});

export default deviceFingerprint;
